import { chartColor } from '../Dashboard/provider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Issue, Props } from './types';
import { useCachedKnownIssues, useConfigurationWarning } from './hooks';
import { useHistory } from 'react-router-dom';
import { useConfig } from '../../eliot-components/src/ConfigProvider/hooks';
import { useAuthUser } from '../../contexts/AuthProvider/hooks';
import ResponseIcon from '@material-ui/icons/Reply';
import { Warning } from '@material-ui/icons';
import {
  useGetReportsQuery,
  useGetTargetSystemsQuery,
} from '../../store/api-slice';

function Alerts({ className, emptyAlerts, onItemClicked }: Props) {
  const config = useConfig();
  const history = useHistory();
  const { authUser } = useAuthUser();

  const {
    state: { knownIssues, numberOfIssues },
  } = useCachedKnownIssues();

  const { data: targetSystems = [] } = useGetTargetSystemsQuery({
    apiBaseURL: config.apiBaseURL,
    orgs: authUser.selectedOrgs,
    filters: [],
  });

  const { data: reports = [] } = useGetReportsQuery({
    apiBaseURL: config.apiBaseURL,
    filters: [],
    orgs: authUser.selectedOrgs,
  });

  const handleItemClick = (link: string) => {
    history.push(link);
    onItemClicked && onItemClicked();
  };

  const tsStatusCodes = targetSystems.filter(
    (ts) => ts.lastStatusCode && ts.lastStatusCode >= 400
  ).length;

  const incompatibleTs = useConfigurationWarning(reports, targetSystems);
  const incompatibleTsCount = incompatibleTs.length;

  const totalNumberOfIssues =
    numberOfIssues +
    targetSystems.filter((ts) => ts.lastStatusCode && ts.lastStatusCode >= 400)
      .length +
    incompatibleTsCount;
  return (
    <Paper className={className}>
      {totalNumberOfIssues > 0 ? (
        <List>
          {Object.values(knownIssues)
            .filter((v) => !!v)
            .map((i?: Issue) =>
              i ? (
                <ListItem
                  key={i.label}
                  button
                  onClick={() => handleItemClick(i.link)}
                >
                  <ListItemIcon>{i.icon()}</ListItemIcon>
                  <ListItemText
                    primary={i.label}
                    secondary={`${i.deviceCount.toLocaleString(
                      'en-US'
                    )} device${i.deviceCount === 1 ? '' : 's'}`}
                  />
                </ListItem>
              ) : null
            )}
          {tsStatusCodes > 0 ? (
            <ListItem
              key={'target-system'}
              button
              onClick={() => {
                history.push('/webhooks');
                onItemClicked && onItemClicked();
              }}
            >
              <ListItemIcon>
                <ResponseIcon color="error" />
              </ListItemIcon>
              <ListItemText
                primary="Status warning"
                secondary={`${tsStatusCodes.toLocaleString()} webhook${
                  tsStatusCodes === 1 ? '' : 's'
                }`}
              />
            </ListItem>
          ) : null}
          {incompatibleTsCount > 0 ? (
            <ListItem
              key={'target-system-incompatible'}
              button
              onClick={() => {
                history.push('/webhooks?configurationWarning=true');
                onItemClicked && onItemClicked();
              }}
            >
              <ListItemIcon>
                <Warning color="error" />
              </ListItemIcon>
              <ListItemText
                primary="Configuration warning"
                secondary={`${incompatibleTsCount.toLocaleString(
                  'en-US'
                )} webhook${incompatibleTsCount === 1 ? '' : 's'}`}
              />
            </ListItem>
          ) : null}
        </List>
      ) : (
        emptyAlerts || (
          <List>
            <ListItem key="no-items">
              <ListItemIcon>
                <CheckCircleIcon
                  style={{
                    color: chartColor('ok'),
                  }}
                />
              </ListItemIcon>
              <ListItemText primary="No alerts" />
            </ListItem>
          </List>
        )
      )}
    </Paper>
  );
}

export default Alerts;
